// extracted by mini-css-extract-plugin
export default {"PlayNow":"TtwlRf5QoSaf1Ybr86Ef","ImgSong":"GzzX6V65TEuCgcEIgZwG","Song":"k_hfPnOqMbuXAOTdV5IE"};